export default {
      id: "big-download-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#big-download",
      toString: function () {
        return this.url;
      }
    }